import { Instance } from 'mobx-state-tree';
import { TagSearchResultModelBase } from './TagSearchResultModel.base';

/* The TypeScript type of an instance of TagSearchResultModel */
export interface TagSearchResultModelType extends Instance<typeof TagSearchResultModel.Type> {}

/* A graphql query fragment builders for TagSearchResultModel */
export { selectFromTagSearchResult, tagSearchResultModelPrimitives, TagSearchResultModelSelector } from './TagSearchResultModel.base';

/**
 * TagSearchResultModel
 */
export const TagSearchResultModel = TagSearchResultModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
